<template>
	<div>
		<v-tabs v-model="activeTab" background-color="transparent" centered color="secondary" slider-color="secondary">
			<v-tab :key="0">ایجاد قالب جدید</v-tab>
			<v-tab :key="1">همه قالب ها</v-tab>

			<v-tabs-items v-model="activeTab" touchless>
				<v-tab-item :key="0">
					<v-card style="background-color: #f1f1f1;" class="py-2 px-2">
						<sms-pattern :alwaysEdit="true" @update="update" @insert="insert" :group="group" :category="category" />
					</v-card>
				</v-tab-item>
				<v-tab-item :key="1">
					<div class="red--text text-center py-3" v-if="!patterns.length">در حال حاضر قالبی ثبت نشده است.</div>
					<v-card v-else v-for="pattern in patterns" :key="pattern.id" style="background-color: #f1f1f1;" class="mb-6 py-2 px-2">
						<sms-pattern :data="{ ...pattern }" @remove="remove" @update="update" @insert="insert" :category="pattern.category" />
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import SmsPattern from './SmsPattern.vue'
	import toast from '@/util/toast'

	export default {
		name: 'SmsPatternManager',
		props: {
			category: Number,
			tab: Number,
			group: String
		},
		emits: ['itemsUpdated'],
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'sms-pattern': SmsPattern
		},
		data() {
			return {
				patterns: [],
				activeTab: 0
			}
		},
		computed: {

		},
		watch: {
			activeTab: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (val === 1 && val !== oldVal)
						this.loadData()
				}
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/smsPattern/list', null)
					.then(
						response => {
							this.patterns = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			update(updatedVal) {
				if (!updatedVal)
					return
				let index = this.patterns.findIndex(x => x.id === updatedVal.id)
				if (index > -1) {
					this.patterns[index] = updatedVal
					this.$emit('itemsUpdated', this.patterns)
				}
			},
			insert(val) {
				if (!val)
					return
				this.patterns.push(val)
				this.$emit('itemsUpdated', this.patterns)
			},
			async remove(id) {
				if (!id) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/smsPattern/delete/' + id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								let index = this.patterns.findIndex(x => x.id === id)
								if (index > -1) {
									this.patterns.splice(index, 1)
									this.$emit('itemsUpdated', this.patterns)
								}
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			}
		}
	}
</script>
<style scoped>
	.pattern-tags {
		list-style: none;
	}

	.pattern-tags li {
		display: inline;
		margin: 3px;
		color: blueviolet;
	}
</style>
